module.exports = __webpack_public_path__ + "img/hero_jp.cd2b593.jpg";